/**
 * Enum vocabularies of the domain model.
 *
 * NORMATIVE SOURCE: docs/02-domain-model.md, realised as SQL domains in
 * docs/04-database-schema.md §3. Values here are verbatim copies and must never
 * drift: the api and the web app both import from this module and neither
 * redeclares a list (ARCHITECTURE.md §3, packages/shared).
 */
export const ASSERTION_STATUS = ['pending', 'validated', 'rejected', 'retired'];
export const GENDER = ['female', 'male', 'other', 'unknown'];
export const LIVING_STATUS = ['living', 'deceased', 'unknown'];
export const RELATION_KIND = ['parent_child', 'union', 'sibling'];
export const PARENT_ROLE = ['mother', 'father', 'parent'];
export const PARENT_BASIS = [
    'biological',
    'adoptive',
    'step',
    'foster',
    'guardianship',
    'unknown',
];
export const UNION_TYPE = ['marriage', 'civil_union', 'partnership', 'unknown'];
export const UNION_END_REASON = [
    'divorce',
    'annulment',
    'separation',
    'widowhood',
    'dissolved',
    'unknown',
];
export const SIBLING_BASIS = ['full', 'half', 'step', 'adoptive', 'unknown'];
export const DATE_QUALIFIER = ['exact', 'about', 'before', 'after', 'estimated'];
export const RETIRE_REASON = ['error', 'superseded', 'privacy', 'duplicate'];
export const USER_ROLE = ['member', 'elder', 'admin'];
export const USER_STATUS = ['invited', 'active', 'suspended'];
export const PROPOSAL_KIND = [
    'add_person',
    'edit_person',
    'retire_person',
    'add_relation',
    'edit_relation',
    'retire_relation',
];
export const PROPOSAL_STATUS = ['open', 'approved', 'rejected', 'expired', 'withdrawn'];
export const VOTE_CHOICE = ['approve', 'reject', 'abstain'];
export const PHOTO_MIME = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'];
/**
 * `audit_log.entity_type` — the **table name** of the target row, plural, as
 * docs/04 §5.12 defines the column ("table name of the target: 'persons',
 * 'proposals', …"). See ARCHITECTURE.md §2.1 C14: docs/05 §13.1 listed singular
 * forms, and lost.
 */
export const AUDIT_ENTITY_TYPE = [
    'persons',
    'relation_assertions',
    'proposals',
    'votes',
    'council_seats',
    'photos',
    'users',
    'sessions',
    'settings',
];
export const NOTIFICATION_KIND = [
    'proposal_opened',
    'proposal_decided',
    'vote_needed',
    'seat_granted',
    'photo_tagged',
];
/**
 * `derived_kind` — docs/05-api-spec.md §6.6. The closed vocabulary the api
 * *filters and reports* on, which is deliberately coarser than the kinship
 * engine's own category keys (docs/06 §8.1): the engine distinguishes
 * `kin.step_pibling` from `kin.composed`, the wire calls both `other` and lets
 * the rendered `label` carry the detail.
 */
export const DERIVED_KIND = [
    'parent',
    'child',
    'grandparent',
    'grandchild',
    'great_grandparent',
    'great_grandchild',
    'sibling',
    'half_sibling',
    'step_sibling',
    'spouse',
    'co_spouse',
    'pibling',
    'nibling',
    'cousin',
    'parent_in_law',
    'child_in_law',
    'sibling_in_law',
    'step_parent',
    'step_child',
    'guardian',
    'ward',
    'other',
];
/** docs/05 §6.6 — `annotations` on a derived relation. */
export const KIN_ANNOTATION = [
    'adoptive',
    'foster',
    'guardianship',
    'by_marriage',
    'former',
    'unknown_basis',
];
/** The traversal alphabet as it appears on the wire (docs/05 §7.1 `edge`). */
export const KIN_EDGE = ['U', 'D', 'M', 'S'];
//# sourceMappingURL=enums.js.map